import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

export class FooterComponent implements OnInit {
  @Input() data: any;
  @Input() pagina;
  @Input() isValid;

  @Output() voltarNavegacao = new EventEmitter();
  @Output() avancarNavegacao = new EventEmitter();

  constructor() {
  }

  ngOnInit() {
  }

  voltar() {
    this.voltarNavegacao.emit();
  }

  avancar() {
    this.avancarNavegacao.emit();
  }
}
